export default {
    state: {
        messageNum: 0,
    },
    mutations: {
        setMessageNum(state, num) {
            state.messageNum = num;
        }
    },
    actions: {
        setMessageNum({commit}, num) {
            commit('setMessageNum', num);
        }
    }
}
